import convertToNestedAttributes from './convert-to-nested-attributes'
import addSchoolYearToParams from './add-school-year-to-params'
import toHasManyAttribute from './to-has-many-attribute'
import mapAllocations from './map-allocations'
import { flow, omit } from 'lodash'
import { update } from 'lodash/fp'

// Keys from the API response that should not be processed by mapAllocations.
// `badges` are handled as individual top-level boolean fields (e.g. cpsBackgroundCheck).
// `skills` is a read-only aggregate returned by the API.
const NON_SERIALIZABLE_KEYS = ['badges', 'skills']

function serializeArtistParams(artist, schoolYear) {
  return flow(
    (params) => omit(params, NON_SERIALIZABLE_KEYS),
    toHasManyAttribute(['detail']),
    update('taPrograms', (programs) =>
      programs ? programs.map(mapAllocations) : []
    ),
    mapAllocations,
    update('partnerships', (partnerships) =>
      partnerships ? partnerships.map(mapAllocations) : []
    ),
    update('credentials', (credentials) =>
      credentials ? credentials.map(mapAllocations) : []
    ),
    update('experiences', (experiences) =>
      experiences ? experiences.map(mapAllocations) : []
    ),
    (params) => addSchoolYearToParams(params, schoolYear),
    (params) =>
      convertToNestedAttributes(params, {
        extraKeys: ['address', 'demographic', 'profile', 'user', 'detail'],
      })
  )(artist)
}

export default serializeArtistParams
